import { ConfirmationAction } from '@app/components/ConfirmationAction';
import { useToast } from '@app/core/notifications';
import { Device, Service } from '@mi-front/core';
import { useAsyncViewCtx } from '@mi-front/ui';
import { Stop as StopIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../../api';

interface PropsP {
  readonly stop: () => void;
  readonly disabled?: boolean;
}

export function ServiceStopP(p: PropsP) {
  const { $t } = useIntl();
  const { notifyInfo, notifyError } = useToast();

  return (
    <ConfirmationAction
      message={$t({
        id: 'streamerBox.viewScreen.services.actions.stop.prompt',
        defaultMessage: '¿Deseas realmente detener el servicio?',
      })}
      onConfirm={async () => {
        try {
          await p.stop();
          notifyInfo(
            $t({
              id: 'streamerBox.viewScreen.services.actions.stop.done',
              defaultMessage: 'Detención de servicio solicitado',
            }),
          );
        } catch (err: any) {
          notifyError(
            $t({
              id: 'streamerBox.viewScreen.services.actions.stop.error',
              defaultMessage: 'No se pudo detener el servicio',
            }),
          );
        }
      }}
    >
      {({ onClick }) => (
        <Button
          size="small"
          variant="outlined"
          color="primary"
          sx={{ marginLeft: 1 }}
          disabled={p.disabled}
          onClick={onClick}
          startIcon={<StopIcon />}
        >
          {$t({
            id: 'streamerBox.viewScreen.services.actions.stop.btn',
            defaultMessage: 'Detener',
          })}
        </Button>
      )}
    </ConfirmationAction>
  );
}

interface Props {
  readonly device: Device;
  readonly service: Service;
}

export function ServiceStop(p: Props) {
  const { device, service } = p;
  const { reload } = useAsyncViewCtx();

  return (
    <ServiceStopP
      stop={async () => {
        await apiClient.streamerBox.stopService(device.id, service.imageId);
        reload();
      }}
      disabled={
        !['Running', 'Downloading', 'Installing', 'Downloaded', 'Restarting'].includes(
          service.status,
        )
      }
    />
  );
}
